import React, { useContext, useState } from 'react';
import ReactDOM from 'react-dom';

import { SwapMainAppContext } from '../../../context/SwapMainAppContext';
import EmailVerificationModal from '../EmailVerificationModal';

import styles from './OperatorSection.module.css';


const OperatorApplicationNewEmailModal = ({ onClose, onUpdateUserProfileEmail, onSubmit }) => {
    const [email, setEmail] = useState('');
    const [isVerifyEmailModalOpen, setIsVerifyEmailModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { userId } = useContext(SwapMainAppContext);
    const isSubmitEnabled = email.trim().length > 0;

    const handleStartEmailVerification = () => {
        setIsVerifyEmailModalOpen(true);
    };

    const handleSubmitOnceEmailVerified = async () => {
        setIsVerifyEmailModalOpen(false);
        setIsSubmitting(true);
        try {
            onUpdateUserProfileEmail(email);
            await onSubmit(email);
        } finally {
            setIsSubmitting(false);
            onClose();
        }
    };


    return ReactDOM.createPortal(
        <>
        <div className={styles.appModalOverlay} onMouseDown={isSubmitting ? undefined : onClose}>
            <div className={styles.appModalContainer} onMouseDown={(e) => e.stopPropagation()}>
                {isSubmitting ? (
                    <div className={styles.appModalLoadingBody}>
                        <span className={styles.appModalSpinner} />
                        <p className={styles.appModalLoadingText}>Verification succeeded! Submitting your application...</p>
                    </div>
                ) : (
                    <>
                        <h2 className={styles.appModalTitle}>Apply for Operator Membership</h2>

                        <p className={styles.appModalBody}>
                            Please enter your email below and follow the steps for verification. Our team will then review your application and email you as soon as your Operator membership is succesfully activated.
                        </p>

                        <input
                            className={styles.appModalEmailInput}
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <div className={styles.appModalButtonRow}>
                            <button className={styles.appModalCancelButton} onClick={onClose}>
                                Cancel
                            </button>
                            <button
                                className={styles.appModalSubmitButton}
                                onClick={handleStartEmailVerification}
                                disabled={!isSubmitEnabled}
                            >
                                Submit
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
        {isVerifyEmailModalOpen && (
            <EmailVerificationModal
                email={email}
                onClose={() => {
                    setIsVerifyEmailModalOpen(false);
                    setEmail('');
                }}
                onChangeEmail={() => {
                    setIsVerifyEmailModalOpen(false);
                    setEmail('');
                }}
                userId={userId}
                onVerified={handleSubmitOnceEmailVerified}
            />
        )}
        </>,
        document.body
    );
};

export default OperatorApplicationNewEmailModal;
